<template>
  <div id="app" data-skin="torder"
    :class="{roomKey: roomKey && !disabledMypageAll, noFrame: !hasFrame, ad: ad.hasAd, isStore: isStore}"
    :data-responsive="responsive"
    :data-preview="isPreview"
    :data-preview_mode="previewMode">
    <div v-if="devSticker" class="devStkr"></div>
    <Error v-if="isError" />
    <Expired v-else-if="isExpired" />
    <div v-else-if="readySetting && !isExpired" class="renderbox" :style="{flex: ad.hasAd && ad.ratioRanding}">
      <div v-if="hasFrame" id="header" :data-arrange="!!setting.skin ? setting.skin.menu : 'left'">
        <Header
          :responsive="responsive"
          :roomKey="roomKey"
          :locale="locale"
          :lang="lang"
          :setting="setting"
          :isPublic="isPublic" />
      </div>
      <div
        v-if="responsive === 'tablet' && (hasFrame ? true : hasRoomNo) && roomKey && (setting && setting.mypage && !setting.mypage.disabledRoom)"
        class="floatingRoomKey notranslate"
        :style="floatingRoomKeyStyle"
        @click="clickRoomKey">
        <span class="roomType">{{ roomKeyType }}</span>
        {{ roomKey }}
      </div>
      <div
        id="container"
        :class="{pageOnly: !hasFrame, autoTranslate: translateType === 'auto'}"
        :style="baseStyle">
        <router-view
          :responsive="responsive"
          :shopResponsive="shopResponsive"
          :roomKey="roomKey"
          :guestType="guestType"
          :translateType="translateType"
          :lang="lang"
          :locale="locale"
          :isPublic="isPublic"
          :style="baseStyle"
          class="content" />
      </div>
      <Translate
        :translateType="translateType"
        :class="{on: translateType === 'auto'}" />
      <Footer v-if="hasFrame" id="footer"
        :locale="locale"
        :lang="lang"
        :setting="setting" />
      <Floating
        v-if="floating && floatingPosition"
        :floating="floating"
        :lang="lang" />
      <ImgViewer v-if="imgSrc"
        :src="imgSrc"
        :locale="locale"
        @close="closeImg" />
      <VideoViewer v-if="videoSrc"
        :src="videoSrc"
        :locale="locale"
        @close="closeVideo" />
      <Talk
        v-if="isTalk"
        :locale="locale"
        :lang="lang" />
      <TalkWs v-if="talkWs" />
      <SetLanguage
        v-if="isPageOnly && isShowLang"
        :isPageOnly="isPageOnly"
        :locale="locale"
        :responsive="responsive"
        :setting="setting"
        :lang="lang"
        :class="{left: hasRoomNo}" />
    </div>
    <div v-if="ad.hasAd && ad.ratioAd && !isExpired" class="adbox" :style="{flex: ad.hasAd && ad.ratioAd}">
      <video :src="`https://istay-guestvalet-file.s3.ap-northeast-2.amazonaws.com/${params.site}/${ad.adVideo}.mp4`" autoplay muted playsinline loop style="width: 100%; height: 100%; object-fit: cover;"></video>
    </div>
    <FacebookMessanger v-if="facebookMessanger" />
    <Layerpopup
      v-if="layerpopup && layerpopupActive && !isExpired"
      :layerpopup="layerpopup"
      :responsive="responsive"
      :roomKey="roomKey"
      :guestType="guestType"
      :translateType="translateType"
      :lang="lang"
      :locale="locale"
      :isPublic="isPublic"
      :site="isAuth"
      @close="closeLayerpopup" />
    <FloatingPage
      v-if="floating && floatingPosition && floatingPage"
      :responsive="responsive"
      :roomKey="roomKey"
      :guestType="guestType"
      :translateType="translateType"
      :lang="lang"
      :locale="locale"
      :isPublic="isPublic"
      :site="isAuth" />
    <Loading v-if="loading" />
  </div>
</template>

<script>
import Error from '@/views/Error'
import Expired from '@/views/Expired'
import API from '@/common/api'
import Translate from '@/views/Translate'
import Header from '@/views/Header'
import Footer from '@/views/Footer'
import Floating from '@/views/Floating'
import Loading from '@/views/Loading'
import PreviewMode from '@/views/PreviewMode'
import ImgViewer from '@/components/Util/ImgViewer'
import VideoViewer from '@/components/Util/VideoViewer'
import FacebookMessanger from '@/components/ThirdParty/FacebookMessanger'
import Layerpopup from '@/views/Layerpopup'
import Talk from '@/components/Talk/Talk'
import TalkWs from '@/components/Talk/TalkWs'
import SetLanguage from '@/components/Util/SetLanguage'
import FloatingPage from '@/views/FloatingPage'

export default {
  components: {
    Error,
    Expired,
    Translate,
    Header,
    Footer,
    Floating,
    Loading,
    PreviewMode,
    ImgViewer,
    VideoViewer,
    FacebookMessanger,
    Layerpopup,
    Talk,
    TalkWs,
    SetLanguage,
    FloatingPage
  },
  computed: {
    devSticker () {
      const DEV_HOSTS = [
        'localhost',
        'edit-test.istay.io', // 개발환경 host가 늘어나면 추가
    ]
      const isDevHost = DEV_HOSTS.includes(window.location.hostname)
      return isDevHost
    },
    isError () {
      return this.$route.name === 'error'
    },
    isExpired () {
      return this.$route.name === 'expired'
    },
    isTalk () {
      return this.$store.getters['talk']
    },
    talkWs () {
      return this.$store.getters['talkWs']
    },
    siteInfo () {
      return this.$store.getters['getSiteInfo']
    },
    partner () {
      return this.$store.state.system.partner
    },
    locale () {
      return this.$store.state.system.locale.data
    },
    params () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    isPageOnly () {
      const siteInfo = this.params
      const isStoreGuestCount = (this.$route.name === 'shop' || this.$route.name === 'store') && this.$store.getters['shop/getIsStoreGuestCount']
      return (siteInfo && siteInfo.frame && siteInfo.frame === 'false') || isStoreGuestCount
    },
    isShowLang () {
      const siteInfo = this.params
      const getShowLangForce = this.$store.getters['common/getShowLangForce']
      return (siteInfo && siteInfo.showLang && siteInfo.showLang === 'true') || getShowLangForce
    },
    ad () {
      const params = this.params
      const ratioRanding = params.adRatio && params.adRatio.split('-')[0]
      const ratioAd = params.adRatio && params.adRatio.split('-')[1]
      return {
        hasAd: params.ad === 'true',
        ratioAd: ratioAd,
        ratioRanding: ratioRanding,
        adVideo: params.adVideo
      }
    },
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (loading) {
        if (loading) {
          document.body.classList.add('layerOn')
        } else {
          document.body.classList.remove('layerOn')
        }
      }
    },
    disabledMypageAll () {
      const mypage = this.setting.mypage
      return mypage && mypage.disabledRoom && mypage.disabledMypage && mypage.disabledCart
    },
    roomKey () {
      const hasSpace = this.params.space && this.params.space !== 'undefined' && this.params.space !== 'na'
      const hasKey = this.params.k && this.params.k !== 'undefined' && this.params.k !== 'na'
      const isOtaValid = !(this.params.otavalid && this.params.otavalid === 'false')
      const isPublic = this.isPublic
      return hasSpace && ((hasKey && isOtaValid) || isPublic) ? this.params.space : null
    },
    roomKeyType () {
      const siteInfo = this.siteInfo
      return siteInfo && siteInfo.category === 'fnb' ? 'Table' : 'Room'
    },
    guestType () {
      const guestUserInfo = this.$store.getters['guest/getGuestUserInfo']
      const roomKey = this.roomKey
      const types = this.setting.guestType
      const guestType = guestUserInfo && guestUserInfo.guestType
      return roomKey && types && guestType && types.find(x => x.id === guestType)
    },
    isPublic () {
      return this.params.public === 'true'
    },
    isAuth () {
      return this.$store.getters['authentication/getAuthInfo'].site
    },
    changeNav () {
      return this.$route.meta.changeNav === true
    },
    hasFrame () {
      const hasFrameParams = this.$store.state.authentication.frame !== 'false'
      const hasFrameStore = this.$route.name === 'store'
      const hasFrameShopType = this.$route.params.shopType !== 'store'
      const changeNavPage = this.$route.name === 'page' && this.$store.state.page.pageType !== null
      const changeNav = this.$route.meta.changeNav === true
      const superadmin = this.$route.name === 'superadmin'
      return hasFrameStore || (hasFrameParams && hasFrameShopType && !changeNavPage && !changeNav && !superadmin)
    },
    hasRoomNo () {
      const hasRoomnoParams = this.$store.state.authentication.roomno === 'true'
      return hasRoomnoParams
    },
    isPreview () {
      return this.$store.state.authentication.preview && this.$store.state.authentication.preview === 'Y'
    },
    setting () {
      const responsive = this.responsive
      const settingData = this.$store.getters['common/getSetting']
      let data = Object.assign({}, settingData)
      if (settingData && settingData.responsive && !this._.isEmpty(settingData.responsive.mobile) && !this._.isEmpty(settingData.responsive.tablet)) {
        data.logo = settingData.responsive[responsive].site.logo
        data.colors = settingData.responsive[responsive].colors
        data.imgs = settingData.responsive[responsive].imgs
        // data.footer = settingData.responsive[responsive].footer
        // data.logo = settingData.responsive[responsive].site.logo
      }
      return data
    },
    baseStyle () {
      const baseColors = this.$store.getters['common/getPointColorsMultiple']
      const baseBg = baseColors([{ target: 'contentsBg', attr: 'background-color' }])
      const baseText = baseColors([{ target: 'contentsText', attr: 'color' }])
      return {
        ...baseBg,
        ...baseText
      }
    },
    floatingRoomKeyStyle () {
      const color = this.setting.colors
      return color && {
        backgroundColor: color.menuBg,
        color: color.menuText
      }
    },
    floating () {
      return this.$store.getters['common/getFloating']
    },
    floatingPosition () {
      if (this.floating && this.floating.active) {
        const mainPage = this.$route.name === 'main' || this.$route.params.id === this.setting.main.page
        const isPage = this.$route.name === 'page' && this.$route.params.id.split('.')[0] === this.params.site // 호텔 자체 페이지일 때만
        return mainPage || (!this.floating.mainOnly && isPage)
      } else {
        return null
      }
    },
    floatingPage () {
      return this.$store.getters['floating/getFloatingPage']
    },
    translateType () {
      const lang = this.$route.params.ln
      const langData = lang && this.setting.lang && this.setting.lang.info.find(l => l.c === lang) ? this.setting.lang.usableList : null
      const type = langData && langData.find(x => x.c === lang) ? (langData.find(x => x.c === lang).t ? 'manual' : 'auto') : 'manual'
      return type
    },
    lang () {
      const translate = this.translateType
      const autoTranslate = translate === 'auto'
      const defaultLang = this.setting.lang ? this.setting.lang.default : 'en'
      const paramsLang = this.$route.params.ln
      return autoTranslate ? defaultLang : paramsLang
    },
    videoSrc () {
      return this.$store.getters['getVideoSrc']
    },
    imgSrc () {
      return this.$store.getters['getImgSrc']
    },
    facebookMessanger () {
      const thirdparty = this.$store.getters['thirdparty/getThirdparty']
      const facebookMessanger = thirdparty && thirdparty.find(x => x.id === 'facebookmessanger')
      return facebookMessanger && facebookMessanger.active
    },
    layerpopupActive () {
      const layerpopup = this.layerpopup && this.layerpopup.setting
      const mobile = layerpopup && layerpopup.mobileActive
      const tablet = layerpopup && layerpopup.tabletActive
      const otaOnly = layerpopup && layerpopup.otaOnlyActive
      const device = this.responsive
      const roomKey = this.roomKey
      return (mobile && device === 'mobile') || (tablet && device === 'tablet') || (otaOnly && roomKey)
    },
    isStore () {
      return this.$route.name === 'store'
    }
  },
  watch: {
    $route: {
      immediate: true,
      async handler(to, from) {
        if (this.expiredByUrl) return

        await this.$nextTick()

        // 공통 유틸
        const getAgentLang = (langs) => {
          const ua = navigator.languages[0] || navigator.language || ''
          const uaCode = ua.split('-')[0]
          return langs.find(x => x === uaCode)
        }

        // 초기 로드일 땐 init에서 언어관련 작업을 우선 하므로 route.from이 존재해야만 실행
        if (from && from.name && from.path) {
          // 언어 결정 로직
          const defaultLang = this.setting && this.setting.lang.priorityAgent
            ? getAgentLang(this.setting.lang.usable) || this.setting.lang.default
            : this.setting && this.setting.lang && this.setting.lang.default

          const paramsLang = to.params.ln
          const isValidLang = paramsLang && this.setting && this.setting.lang.info.some(l => l.c === paramsLang)
          const ln = isValidLang ? paramsLang : defaultLang

          // 번역/로케일 설정 (중간마다 최신 호출 여부 확인)
          this.$store.commit('translate', this.translateType)

          // 잘못된 ln이면 replace하되, **변경이 있을 때만** 호출 (무한 replace 방지)
          if (!isValidLang && paramsLang !== defaultLang) {
            // replace 이후 즉시 반환 — 다음 watch 호출이 새 to로 다시 들어옴
            this.$router.replace({
              name: to.name,
              params: { ...to.params, ln: defaultLang }
            })
            return;
          }

          // 스토어/상태 적용
          this.$store.commit('system/setLocale', ln)
          this.translate.to = ln

          // 동일한 샵(스토어) 내 카테고리 이동인지 체크
          const isSameShopOrStoreRoute = (from, to) => {
            return ['shop', 'store'].includes(from.name) &&
            from.name === to.name &&
            from.params.shopPageId === to.params.shopPageId
          }
          // 레이어 팝업은 동일 상점/스토어 라우트면 스킵
          if (!isSameShopOrStoreRoute(from, to)) {
            // setLayerpopup이 비동기일 수 있으니 호출 전후로 최신 호출 여부 점검
            const maybePromise = this.setLayerpopup()
            if (maybePromise && typeof maybePromise.then === 'function') {
              await maybePromise
            }
          }
        }

        // 기타 처리
        this.$store.commit('dimmed', false)
      }
    },
    isAuth (isAuth) {
      if (isAuth) {
        this.init()
      }
    }
  },
  async created () {
    const expired = this.checkExpired()
    if (expired) return

    if (!this.isAuth) {
      this.$router.push({
        name: 'error',
        params: {
          reason: 'empty_siteid'
        }
      })
    } else {
      this.track()
      this.getDeviceOs()
      try {
        await this.checkOtaKey()
      } catch (e) {
        console.error(e)
      }
      this.init()
      this.$store.commit('system/setPartner')
      window.addEventListener('resize', this.checkDeviceSize)
      window.addEventListener('click', this.checkLink)
    }
  },
  mounted () {
    this.checkDeviceSize()
    // document.addEventListener('click', this.scrollHiddenOnDimm, { capture: true })
    this.$root.$on('app:retry', () => {
      this.readySetting = false
      this.readyMenu = false
      this.init()
    })
  },
  beforeDestroy () {
    this.$root.$off('app:retry')
  },
  destroyed () {
    window.removeEventListener('resize', this.checkDeviceSize)
  },
  data () {
    return {
      expiredByUrl: false, // 만료된 url인지?
      deviceOs: 'ANDROID',
      rendered: false,
      translate: {
        from: '',
        to: ''
      },
      responsive: 'mobile',
      shopResponsive: 'mobile',
      previewMode: 'm',
      layerpopup: null,
      readySetting: false,
      readyMenu: false
    }
  },
  methods: {
    track () {
      const params = window.location.search
      this.$gtag.pageview({
        page_path: params,
        page_title: 'enterance'
      })
      this.$gtag.event('enterance', {
        event_category: 'enterance',
        event_label: params
      })
    },
    checkExpired () {
      // 만료일이 있는 exp 쿼리스트링이 있는 경우(만료일이 있는 qr코드) 만료정보(exp)를 체크한다
      const params = new URLSearchParams(window.location.search)
      const exp = params.get('exp')
      if (!exp) return false

      const now = Math.floor(Date.now() / 1000)
      const expired = now > Number(exp)

      if (expired) {
        this.expiredByUrl = true
        this.$router.replace({ name: 'expired' })
      }

      return expired
    },
    getDeviceOs () {
      const userAgent = navigator.userAgent.toLowerCase()
      let os
      if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
        os = 'IOS'
      } else {
        os = 'ANDROID'
      }
      this.$store.commit('setDeviceOs', os)
    },
    async checkOtaKey () {
      const ota = await this.$store.dispatch('authentication/getOtaKey')
      // this.$store.dispatch('guest/getGuestInfo')
      this.$store.dispatch('guest/getUserInfo')
      return ota
    },
    checkDeviceSize (e) {
      if (window.innerWidth < 768) {
        this.responsive = 'mobile'
      } else if (window.innerWidth >= 768) {
        this.responsive = 'tablet'
      } 
      if (window.innerWidth < 1024) {
        this.shopResponsive = 'mobile'
      } else if (window.innerWidth >= 1024) {
        this.shopResponsive = 'tablet'
      }
    },
    checkLink (e) {
      const anchor = e.target.nodeName === 'A'
      if (anchor) {
        const href = e.target.getAttribute('href')
        if (href === '#' || href === '') {
          e.preventDefault()
        } else if (href === '#stayTalk') {
          e.preventDefault()
          this.$store.commit('talk', true)
        }
      }
    },
    async init () {
      const getAgentLang = (langs) => {
        const ua = (navigator.languages && navigator.languages[0]) || navigator.language || ''
        const uaCode = ua.split('-')[0]
        return Array.isArray(langs) ? langs.find(x => x === uaCode) : undefined
      }

      if (!this.isAuth) {
        this.rendered = true
        return
      }

      this.$store.commit('loading', true)

      try {
        const router = this.$route

        // 1) 커스텀 리소스
        try {
          await this.$store.dispatch('common/setCustomResource')
        } catch (e) {
          console.log('[setCustomResource] failed', e)
        }

        // 2) setting 로드
        const res = await this.$store.dispatch('common/loadSetting')

        const menuId = res.main && res.main.menu
        this.readySetting = true

        // 3) 초기 언어 설정 (기존 로직 최대 유지)
        const isValidLn = (ln) => ln && res.lang && Array.isArray(res.lang.info) && res.lang.info.some(l => l.c === ln)

        const desiredLang = (!router.params.ln || !isValidLn(router.params.ln))
          ? (res.lang && res.lang.priorityAgent
              ? (getAgentLang(res.lang.usable) || res.lang.default)
              : (res.lang ? res.lang.default : 'en'))
          : (router.params.ln === 'zh' ? 'zh-CN' : router.params.ln)

        // 라우터 params ln 적용
        // ※ 무한 replace 방지를 위해 현재값과 다를 때만
        if (router.params.ln !== desiredLang) {
          await this.$router.replace({ params: { ...router.params, ln: desiredLang } })
        }

        // translate 타입 결정 (기존 로직)
        const langData = res.lang && res.lang.usableList ? res.lang.usableList : []
        const alwaysAuto = !!this.$route.meta && this.$route.meta.translate === 'always'
        const found = langData.find(x => x.c === desiredLang)
        const transType = (found && found.t && !alwaysAuto) ? 'manual' : 'auto'

        this.translate.from = res.lang ? res.lang.default : 'en'
        this.$store.commit('translate', transType)
        this.$store.commit('system/setLocale', desiredLang)

        // setLang 등
        try {
          await this.$store.dispatch('common/setLang', desiredLang)
        } catch (e) {
          console.log('[setLang] failed', e)
        }

        // 4) 기타 비동기들은 병렬로 호출
        this.$store.dispatch('thirdparty/getThirdparty').catch(() => {})

        this.$store.dispatch('common/getSiteinfo')
          .then((siteinfo) => {
            if (siteinfo && (siteinfo.useStayTalk || (siteinfo.stayTalk && siteinfo.stayTalk.useStayTalk))) {
              this.$store.commit('talkWs', true)
            }
          })
          .catch(() => {})

        // 5) frame 여부에 따라 메뉴 로드 -> rendered=true
        if (this.$store.state.authentication.frame !== 'false') {
          this.$store.dispatch('common/loadFloating').catch(() => {})

          // loadMenu는 실패해도 rendered는 열어야 함
          try {
            await this.$store.dispatch('common/loadMenu', menuId)
            this.readyMenu = true
          } catch (e) {
            console.log('[loadMenu] failed', e)
          }
        }

        // 6) 스테이톡 파라미터 처리
        if (this.params && this.params.talk) {
          // localStorage.setItem(`${this.params.site}_stayTalk`, this.params.talk)
          this.$store.commit('talk', true)
        }

        // 7) 레이어팝업
        this.$store.dispatch('layerpopup/getLayerpopup')
          .then(() => this.setLayerpopup())
          .catch(() => {})
        
        this.rendered = true

      } catch (e) {
        this.rendered = true

        console.log('[init] failed', e)

        // error 라우트로 이동
        const reason = e && (e.code || e.message) ? (e.code || e.message) : 'setting'
        const retryPath = (this.$route && this.$route.fullPath) ? this.$route.fullPath : '/'
        this.$router.replace({
          name: 'error',
          params: { reason: String(reason) },
          query: {
            retry: retryPath
          }
        }).catch(() => {})
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async loadPage (id) {
      const siteId = id.split('.')[0]
      const file = `page/item/${id}.json`
      try {
        const res = await this.$axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${siteId}&file=${file}`)
        return res && res.data && res.data.message ? id : false
      } catch (ex) {
        return false
      }
    },
    async loadPageAll (ids) {
      if (ids) {
        return Promise.all(ids.map(x => this.loadPage(x))).then((res) => {
          return res
        })
      } else {
        return []
      }
    },
    async setLayerpopup () {
      const list = this.$store.getters['layerpopup/getLayerpopup']
      const route = this.$route.name
      const params = this.$route.params
      const targetId = getParamsId(route)
      const setting = this.setting
      const mainPageId = setting && setting.main.page
      function getParamsId (routeName) {
        let result = routeName
        switch (routeName) {
          case 'page':
            result = 'id'
            break
          case 'product':
            result = 'productId'
            break
          case 'shop':
            result = 'shopPageId'
            break
          case 'store':
            result = 'shopPageId'
            break
          case 'reservation':
            result = 'reservationId'
            break
          default :
            result = routeName
            break
        }
        return result
      }
      const layerpopup = list && list.length
        ? list.find(x => {
          return route === 'main'
            ? x.targetId === mainPageId
            : route.includes(x.target)
              ? x.targetId === params[targetId]
              : x.target === 'shop' && route.includes('store') || (x.target === 'shortcut' && x.targetId === targetId)
        })
        : null
      const validPages = await this.loadPageAll(layerpopup && layerpopup.popup)
      this.layerpopup = validPages && validPages.length > 0 ? {
        ...layerpopup,
        popup: layerpopup.popup.filter(x => validPages.includes(x))
      } : null
    },
    setPreviewMode (mode) {
      this.previewMode = mode
    },
    scrollHiddenOnDimm (e) {
      setTimeout(() => {
        const layer = document.querySelector('.layer')
        if (layer) {
          document.body.classList.add('layerOn')
        } else {
          document.body.classList.remove('layerOn')
        }
      }, 400)
    },
    closeImg () {
      this.$store.commit('setImgSrc', null)
    },
    closeVideo () {
      this.$store.commit('setVideoSrc', null)
    },
    closeLayerpopup () {
      this.layerpopup = null
    },
    clickRoomKey (e) {
      const mypage = this.setting && this.setting.mypage
      const roomOnly = mypage && mypage.disabledMypage
      if (roomOnly) {
        e.preventDefault()
      } else {
        this.$router.push({
          name: 'mypage'
        })
      }
    }
  }
}
</script>
